import { useState } from "react";
import axios from "axios";
import styles from "../houseManagerProfile.module.css";
import useProfileData from './hooks/useProfileData';
import { useParams } from "react-router-dom";

const baseURL = `${process.env.REACT_APP_API_URL}`

export default function ContractForm() {
    const { profile } = useProfileData();
    const [success, setSuccess] = useState('');
    const [newContract, setNewContract] = useState({
          terms: '',
          start_date: '',
          end_date: '',
          status: '',
          payment_amount: '',
          payment_status: '',
          is_renewable: false,
          days_per_month: '',
          termination_date: '',
          termination_reason: '',
          contract_document: '',
        });
    const [isModalOpen, setIsModalOpen] = useState(false);
    const LoginUserId = localStorage.getItem('userId')
    const { id } = useParams();

    const handleOpenModal = () => setIsModalOpen(true)
    const handleCloseModal = () => setIsModalOpen(false)

    const handleCreateContract = async (id, e) => {
        e.preventDefault();
        setSuccess('')

        const {start_date, end_date} = newContract;

        if (new Date(end_date) <= new Date(start_date)) {
        console.error('End date should be after start date')
        return;
        }

        if (newContract.contract_document && newContract.contract_document.size > 5 * 1024 * 1024) {
        console.error('Contract document size should be less than 5MB')
        return;
        }

        const token = localStorage.getItem('accessToken')
        if (!token) {
        console.error('AccessToken not found in localStorage');
        console.error('Please log in to create a contract')
        return;
        }

        const formData = new FormData();
        formData.append('house_manager', id);
        formData.append('employer', LoginUserId);
        formData.append('contract_document', newContract.contract_document);

        Object.keys(newContract).forEach((key) => {
        if (key !== 'contract_document[key]') {
            formData.append(key, newContract[key]);
        }
        });


        try {
        const response = await axios.post(
            `${baseURL}/profiles/create_contract/`, 
            formData,
            {
            headers: {
            Authorization: `Bearer ${token}`},
            },
        );
        setNewContract(response.data.contract)
        setSuccess(response.data.message)
        console.log('Contract created successfully:', response.data.contract)
        setIsModalOpen(false)
        } catch (error) {
        if (error.response) {
            console.error(error.response.data.error || 'An error occured')
            console.log('Error Response:', error.response.data)
        } else {
            console.error('An error occured while creating the contract')
        }
        }
    };

    const handleContractInputchange = (e) => {
        setNewContract({...newContract, [e.target.name]: e.target.value});
    };

    return (
        <>
            {isModalOpen && (
            <div className={styles.modal}>
                <div className={styles.modalContent}>
                <h3>Contract for {profile.first_name} {profile.last_name}</h3>
                <form onSubmit={(e) => handleCreateContract(id, e)}>
                    <label>
                    Terms:
                    <textarea 
                        name="terms"
                        value={newContract.terms}
                        onChange={handleContractInputchange}
                    />
                    </label>
                    <br />
                    <label>
                    Start Date:
                    <input 
                        type="date"
                        name="start_date"
                        value={newContract.start_date}
                        onChange={handleContractInputchange}
                    />
                    </label>
                    <br />
                    <label>
                    End Date:
                    <input 
                        type="date"
                        name="end_date"
                        value={newContract.end_date}
                        onChange={handleContractInputchange}
                    />
                    </label>
                    <br />
                    <label>
                    Payment Day: 
                    <select 
                        name="payment_day"
                        value={newContract.payment_day}
                        onChange={handleContractInputchange}
                    >
                        <option value="Daily">Daily</option>
                        <option value="Monthly">Monthly</option>
                        <option value="Yearly">Yearly</option>
                    </select>
                    </label>
                    <br />
                    <label>
                    Payment Amount:
                    <input 
                        type="number"
                        name="payment_amount"
                        value={newContract.payment_amount}
                        onChange={handleContractInputchange}
                    />
                    </label>
                    <br />
                    <label>
                    Renewable: 
                    <input 
                        type="checkbox"
                        name="is_renewable"
                        checked={newContract.is_renewable}
                        onChange={(e) => setNewContract({
                        ...newContract, is_renewable:e.target.checked
                        })}
                    />
                    </label>
                    <br />
                    <label>
                    Days To Work Per Month:
                    <input 
                        type="number"
                        name="days_per_month"
                        value={newContract.days_per_month}
                        onChange={handleContractInputchange}
                    />
                    </label>
                    <br />
                    <label>
                    Termination Date:
                    <input 
                        type="date"
                        name="termination_date"
                        value={newContract.termination_date}
                        onChange={handleContractInputchange}
                    />
                    </label>
                    <br />
                    <label>
                    Termination Reason:
                    <textarea 
                        name="termination_reason"
                        value={newContract.termination_reason}
                        onChange={handleContractInputchange}
                    />
                    </label>
                    <br />
                    <label>
                    Contract Document:
                    <input 
                        type="file"
                        name="contract_document"
                        onChange={(e)=> setNewContract({
                        ...newContract, contract_document: e.target.files[0]
                        })}
                    />
                    </label>
    
                    <button type="submit">Create Contract</button>
                    <button type="button" onClick={handleCloseModal}>Cancel</button>
                </form>
                </div>
            </div>
        )}
        </>
    )
}